<template v-slot:append>
  <v-dialog max-width="90%" min-width="50%" min-height="85vh" scrollable persistent no-click-animation
      v-bind="computedProps"
      v-on="computedListeners"
      v-model="dialog">
    <v-card>
      <v-toolbar elevation="2" color="#2F75B5" dark dense>
        <v-spacer/>
        <v-toolbar-title>
          定型コース検索
        </v-toolbar-title>
        <v-spacer/>
        <v-btn @click="onCloseClick" text>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid class="px-2 base-area">
          <!-- **************************************************************************************************** --
            -- 検索条件
            -- **************************************************************************************************** -->
          <div class="pa-2">
            <v-row no-gutters justify="start" ref="_calcHeight-Row1">
              <dd-sub-header>
                <span>以下の検索条件で絞り込む</span>
                <span style="float: right;">
                  <dd-transparent-button :minWidth="140" @click="isConditionHide = !isConditionHide">
                  <div v-if="!isConditionHide" class="condition-expansion">検索条件を閉じる<v-icon>mdi-chevron-up</v-icon></div>
                  <div v-else class="condition-expansion">検索条件を開く<v-icon>mdi-chevron-down</v-icon></div>
                  </dd-transparent-button>
                </span>
              </dd-sub-header>
            </v-row>
            <div v-if="!isConditionHide" class="px-1 pt-0 pb-2 condition-area">
              <v-row no-gutters align-content="center" ref="_calcHeight-Row2">
                <v-col :xs="6" :sm="6" :md="6" :lg="3" :xl="3" :cols="6" class="px-1">
                  <dd-text-box
                    label="コースNo"
                    v-model="conditions.teikeiCourseNo"
                    ref="teikeiCourseNo"
                    :length="50"
                    :valueType="Ctrls.InputTypes.Number"
                    tooltipText="検索したいコースNoを入力しましょう。<br>入力した値であいまい検索されます。"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                  />
                </v-col>
                <v-col :xs="6" :sm="6" :md="6" :lg="3" :xl="3" :cols="12" class="px-1">
                  <dd-text-box
                    label="コース名称"
                    v-model="conditions.teikeiCourseNm"
                    ref="teikeiCourseNm"
                    :length="50"
                    :valueType="Ctrls.InputTypes.Free"
                    tooltipText="検索したいコース名称を入力しましょう。<br>入力した値であいまい検索されます。"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                  />
                </v-col>
                <v-col :xs="6" :sm="6" :md="6" :lg="3" :xl="3" :cols="12" class="px-1">
                  <dd-code-text-box
                    label="荷主"
                    v-model="conditions.tokuisakiCd"
                    ref="tokuisakiCd"
                    :length="100"
                    :required="false"
                    :valueType="Ctrls.InputTypes.Free"
                    titleText="取引先マスタ検索"
                    :headerList="mstTorihikisakiHeader"
                    item-value="torihikisakiCd"
                    item-text="torihikisakiNm"
                    :itemList="filteredMstTokuisakiList"
                    tooltipText="検索したい得意先を入力しましょう。<br>未入力の場合は全得意先が対象になります。"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                  />
                </v-col>
                <v-col :xs="6" :sm="6" :md="6" :lg="3" :xl="3" :cols="6" class="px-1" v-show="false">
                  <dd-code-text-box
                    label="営業所"
                    v-model="conditions.tantoEigyoshoCd"
                    ref="tantoEigyoshoCd"
                    :required=false
                    :length=100
                    :valueType="Ctrls.InputTypes.Free"
                    :itemList="filteredEigyoshoList"
                    titleText="営業所検索"
                    item-value="eigyoshoCd"
                    item-text="eigyoshoNm"
                    :headerList="mstEigyoshoHeader"
                    tooltipText="検索したい営業所を入力しましょう。<br>未入力の場合は全営業所が対象になります。"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                    />
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" ref="_calcHeight-Row3" v-if="viewStyleType !== 1">
                <v-col :xs="6" :sm="6" :md="6" :lg="3" :xl="3" :cols="6" class="px-1">
                  <dd-text-box
                    label="発地"
                    v-model="conditions.hatsuchiNm"
                    ref="hatsuchiNm"
                    :length="100"
                    :required="false"
                    :valueType="Ctrls.InputTypes.Free"
                    tooltipText="検索したい発地を入力しましょう。<br>未入力の場合は全発地が対象になります。"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                    />
                </v-col>
                <v-col :xs="6" :sm="6" :md="6" :lg="3" :xl="3" :cols="6" class="px-1">
                  <dd-text-box
                    label="着地"
                    v-model="conditions.chakuchiNm"
                    ref="chakuchiNm"
                    :length="100"
                    :required="false"
                    :valueType="Ctrls.InputTypes.Free"
                    tooltipText="検索したい着地を入力しましょう。<br>未入力の場合は全着地が対象になります。"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                    />
                </v-col>
                <v-col :xs="6" :sm="6" :md="6" :lg="3" :xl="3" :cols="6" class="px-1">
                  <dd-text-box
                    label="商品"
                    v-model="conditions.hinmeiNm"
                    ref="hinmeiNm"
                    :length="100"
                    :valueType="Ctrls.InputTypes.Free"
                    tooltipText="検索したい商品を入力しましょう。<br>未入力の場合は全商品が対象になります。"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                  />
                </v-col>
                <v-col :xs="6" :sm="6" :md="6" :lg="3" :xl="3" :cols="6" class="px-1">
                  <dd-text-box
                    label="注文番号"
                    v-model="conditions.chumonNo"
                    ref="chumonNo"
                    :length="20"
                    :valueType="Ctrls.InputTypes.Free"
                    tooltipText="検索したい注文番号を入力しましょう。<br>入力した値であいまい検索されます。"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                  />
                </v-col>
              </v-row>
              <v-row class="mt-2" no-gutters justify="center" ref="_calcHeight-Row4">
                <dd-custom-button
                  :rounded="true"
                  :minWidth="200"
                  :large="true"
                  :tooltipText="`入力された検索条件で登録済みの受注を検索します`"
                  :enableToolTip="helpUseFlg"
                  :tooltipBottom="true"
                  @click="onSearchButtonClick">
                  検索をする
                </dd-custom-button>
                <a
                  class="condition-clear"
                  @click="onClearButtonClick">
                  条件をクリア
                </a>
              </v-row>
            </div>
          </div>

          <div class="px-1 py-2" v-if="filteredRows.length > 0">
            <v-row no-gutters>
              <v-col :xs="5" :sm="5" :md="5" :lg="2" :xl="2" :cols="5" class="px-1">
                <span class="search-number">{{ filteredRows.length }}</span>件 の検索結果
              </v-col>
              <v-col :xs="7" :sm="7" :md="7" :lg="4" :xl="4" :cols="7" v-if="!abbreviatedDisplay">
                <a
                  class="condition-clear-bottom"
                  @click="onClearButtonClick">
                  条件をクリア
                </a>
              </v-col>
              <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="6" class="mt-2" v-if="!abbreviatedDisplay">
                <span class="text-right-black-bold">さらにフリーワードで絞り込む</span>
              </v-col>
              <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="6" class="px-1">
                <dd-narrow-down-text-box label="" adjustStyle="padding-top:0px" v-model="searchText"/>
              </v-col>
            </v-row>

            <hr class="section-line mb-2">

            <v-row no-gutters justify="end" v-if="!abbreviatedDisplay">
              <v-col :cols="6" class="d-sm-block" />
              <v-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6" :cols="12">
                <v-row no-gutters justify="end">
                  <dd-select-items-per-page
                    ref="pagination1"
                    :itemsPerPage.sync="itemsPerPage"
                    :currentPage.sync="page"
                    :items="filteredRows"
                    @changeItemsPerPage="changeItemsPerPage"
                    @changePage="changePage"
                  />
                </v-row>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-data-table
                item-key="id"
                :headers="headers"
                :items="filteredRows"
                :custom-filter="filtering"
                :search="searchText"
                :items-per-page="itemsPerPage"
                :page.sync="page"
                @dblclick:row="onRowDoubleClick"
                no-data-text="対象データはありません"
                fixed-header
                :hide-default-header="abbreviatedDisplay"
                hide-default-footer
                locale="ja-jp"
                dense
              >
                <template v-slot:[`item.actions`]="{item}">
                  <template>
                    <v-chip
                      small
                      color="primary"
                      @click="onRowSelectButtonClick(item)"
                    >
                      選択
                    </v-chip>
                  </template>
                </template>
                <template v-if="$scopedSlots.body" v-slot:body="slotProps">
                  <slot name="body" :displayItems="computedDisplayItems" :headers="slotProps.headers" :selectRow="onRowSelectButtonClick">
                    <tbody>
                      <tr
                        v-for="(row, rowIndex) in computedDisplayItems"
                        :key="getRowKey(row, rowIndex)"
                      >
                      </tr>
                    </tbody>
                  </slot>
                </template>
              </v-data-table>
            </v-row>
          </div>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-row no-gutters class="px-1 py-0 mt-3">
          <v-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6" :cols="12">
            <dd-transparent-button :minWidth="120" @click="onCloseClick">
              <v-icon color="#1F2B38">mdi-close-circle</v-icon>ヘルプを閉じる
            </dd-transparent-button>
          </v-col>
          <v-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6" :cols="12" v-if="filteredRows.length > 0 && !abbreviatedDisplay">
            <v-row no-gutters justify="end">
              <dd-select-items-per-page
                ref="pagination2"
                :itemsPerPage.sync="itemsPerPage"
                :currentPage.sync="page"
                :items="filteredRows"
                @changeItemsPerPage="changeItemsPerPage"
                @changePage="changePage"
              />
            </v-row>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import controls from '@/rahmen/controls'
import modals from '@/ddv2.library/modals'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import header from '@/ddv2.library/header'
import Swal from 'sweetalert2'

import { mapGetters } from 'vuex'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdSelectItemsPerPage from '@/components/DdSelectItemsPerPage'

const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'DdTeikeiCorseSearchDialogForLite',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdNarrowDownTextBox,
    DdSelectItemsPerPage,
    DdCodeTextBox,
    DdSubHeader,
    DdTextBox
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * ダイアログタイトル
     */
    titleText: String,
    /**
     * コンプリートリスト
     */
    itemList: Array,
    /**
     * 1行選択
     */
    singleSelect: {
      type: Boolean,
      default: true
    },
    customHeaders: Array,
    abbreviatedDisplay: {
      type: Boolean,
      default: false
    },
    itemsPerPage: {
      type: Number,
      default: 100
    }
  },
  data: () => ({
    conditions: {
      teikeiCourseNo: '',
      teikeiCourseNm: '',
      tokuisakiCd: '',
      chumonNo: '',
      tantoEigyoshoCd: '',
      hacchusakiCd: '',
      hatsuchiNm: '',
      chakuchiNm: ''
    },
    // フィルター定義 －－ここから－－
    teikeiCourseFilterConditions: {
      teikeiCourseNo: '',
      teikeiCourseNm: '',
      tokuisakiCd: '',
      tantoEigyoshoCd: '',
      hacchusakiCd: '',
      hatsuchiNm: '',
      chakuchiNm: ''
    },
    // フィルター定義 －－ここまで－－
    searchText: '',
    ctypes: controls,
    // 拡張パネル
    expansionPanel: [0, 1],
    /**
     * 一覧内容
     */
    isConditionHide: false,
    rows: [],
    loading: false,
    dialog: false,
    // 一覧制御用
    selected: [],
    page: 1
    /*
     *
     */
  }),

  created () {
    console.log('screen created')
    this.$store.dispatch('system/setViewTitle', '固定貨物検索')
    this.mstEigyoshoHeader = header.mstEigyoshoHeaders
    this.mstTorihikisakiHeader = header.mstTorihikisakiHeaders
    this.mstHacchakuchiHeaders = header.mstHacchakuchiHeaders
  },
  mounted () {
    this.initialize()
  },
  watch: {
    showDialog: {
      immediate: true,
      handler (v) {
        this.dialog = v
        if (v === true) {
          this.initBindVariables()
        }
      }
    },
    dialog (v) {
      // ★ 親に閉じたことを通知（close false を返す仕様に合わせる）
      if (v === false && this.showDialog === true) {
        this.$emit('close', false)
      }
    }
  },
  computed: {
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      userSettings: 'DDMasters/mstUserSettings',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    viewStyleType () {
      const type = [undefined, null].includes(this.userSettings) || [undefined, null].includes(this.userSettings.useNippoEditType) ? 1 : this.userSettings.useNippoEditType
      return type
    },
    // 営業所マスタフィルター --> ここから
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    // 営業所マスタフィルター <-- ここまで
    // 取引先マスタフィルター --> ここから
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    filteredMstHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === true
      })
    },
    // 取引先マスタフィルター <-- ここまで
    // 発着地マスタフィルター --> ここから
    filteredHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 発着地マスタフィルター <-- ここまで
    filteredRows () {
      const self = this
      return this.rows.filter(function (elem) {
        return self.isTeiekiCourseSearchCheck(elem)
      })
    },
    computedProps () {
      return {
        ...this.$props,
        persistent: true,
        noClickAnimation: true,
        maxWidth: '85%'
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    isSelectButtonDisabled () {
      return this.selected.length === 0
    },
    calcHeightTable () {
      if (this.expansionPanel.length === 1) {
        return this.tableHeight * 0.8
      }
      return this.tableHeight * 0.41
    },
    searchedRows () {
      const text = (this.searchText || '').trim()
      if (!text) return this.filteredRows

      // v-data-table の検索と同等に寄せるなら custom-filter を呼ぶ
      // filtering が無い/使わないなら、単純に全項目文字列検索でもOK
      return this.filteredRows.filter(row => {
        // 例：全プロパティを対象に部分一致
        return Object.keys(row).some(k => String(row[k] ?? '').includes(text))
      })
    },
    computedDisplayItems () {
      const rows = this.searchedRows || []
      const per = this.itemsPerPage || 10
      const page = this.page || 1
      const start = (page - 1) * per
      return rows.slice(start, start + per)
    }
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: [],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('ThKoteiKamotsuNoSearchDialog.defineHeaderPromise')
            if (self.customHeaders && self.customHeaders.length > 0) {
              self.headers = self.customHeaders
            } else {
              self.headers = [
                { text: '', value: 'actions', align: 'center' },
                { text: 'コースNo', value: 'teikeiCourseNo' },
                { text: 'コース名称', value: 'teikeiCourseNm' },
                { text: '荷主', value: 'tokuisakiNm' },
                { text: '発地', value: 'hatsuchiDisp' },
                { text: '発時刻', value: 'hatsuchiHmsDisp' },
                { text: '経由地', value: 'keiyuchiId1Disp' },
                { text: '着地', value: 'chakuchiDisp' },
                { text: '着時刻', value: 'chakuchiHmsDisp' },
                { text: '請求車種', value: 'seikyuShashuSbtNm' },
                { text: '運賃計算方法', value: 'unchinKeisanKbnNm' },
                { text: '商品', value: 'hinmeiDisp' },
                { text: '数量', value: 'juchuSuryo', align: 'end' },
                { text: '単位', value: 'unitKbnNm' },
                { text: '重量', value: 'juchuJuryo', align: 'end' },
                { text: '単価', value: 'tanka', align: 'end' },
                { text: '運賃', value: 'kihonUnchin', align: 'end' },
                { text: '運賃(高速)', value: 'hiwayPrice', align: 'end' },
                { text: 'その他課税', value: 'unchinHokaKingaku', align: 'end' },
                { text: 'その他非課税', value: 'unchinHokaHikazei', align: 'end' },
                { text: '燃料サーチャージ', value: 'nenryoSurcharge', align: 'end' },
                { text: '積込料', value: 'tsumikomiKingaku', align: 'end' },
                { text: '取卸料', value: 'torioroshiKingaku', align: 'end' },
                { text: '待機時間', value: 'taikiJikanDisp', align: 'center' },
                { text: '待機時間単価', value: 'taikiJikanTanka', align: 'end' },
                { text: '待機時間料', value: 'taikiJikanKingaku', align: 'end' },
                { text: 'その他付帯業務料', value: 'futaiGyomuKingaku', align: 'end' },
                { text: '時間割増金額', value: 'jikanWarimashiKingaku', align: 'end' },
                { text: '距離割増金額', value: 'kyoriWarimashiKingaku', align: 'end' },
                { text: '割増その他', value: 'warimashiSonotaKingaku', align: 'end' },
                { text: '請求金額合計', value: 'seikyuGokei', align: 'end' },
                { text: '請求用備考', value: 'seikyuBiko' },
                { text: '支払運賃', value: 'yoshaUnchin', align: 'end' },
                { text: '支払運賃(高速)', value: 'yoshaHiwayPrice', align: 'end' },
                { text: '支払その他課税', value: 'yoshaUnchinHokaKingaku', align: 'end' },
                { text: '支払その他非課税', value: 'yoshaUnchinHokaHikazei', align: 'end' },
                { text: '支払金額合計', value: 'shiharaiGokei', align: 'end' },
                { text: '支払用備考', value: 'shiharaiBiko' }
              ]
            }
            resolve()
          })
        },
        initializeInputPromise: (c) => {
          this.initBindVariables()
        },
        savedInputRestorePromise: (c) => {
          console.log('savedInputRestorePromise')
          // ユーザ保存項目の復元
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('ThKoteiKamotsuNoSearchDialog.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        settingViewScroll: () => {
          return true
        },
        researchPromise: (c) => {
          console.log('ThKoteiKamotsuNoSearchDialog.researchPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('ThKoteiKamotsuNoSearchDialog.restoreViewPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.searchText = c.cache.value.searchText || ''
            this.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('ThKoteiKamotsuNoSearchDialog.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            resolve()
          })
        },
        settingLoadEffect: function () {
          return true
        }

      }
      this.initializeForViewer(opt)
    },
    onRowDoubleClick: function (e, f) {
      /**
       * 選択時クローズ処理
       * @event doubleClick
       * @type {Event}
       */
      console.log('row double clicked', e)
      console.log('row double clicked', f)
      this.$emit('close', f.item)
      this.initBindVariables()
      this.searchText = ''
      this.selected = []
    },
    onRowSelectButtonClick: function (item) {
      console.log('onRowSelectButtonClick', item)
      this.$emit('close', item)
      this.initBindVariables()
      this.dialog = false
    },
    onSearchButtonClick: function (e) {
      this.selected = []
      this.teikeiCourseFilterConditions = Object.assign({}, this.conditions)
    },
    isTeiekiCourseSearchCheck (elem) {
      const self = this
      return (!self.teikeiCourseFilterConditions.teikeiCourseNo || String(elem.teikeiCourseNo).indexOf(self.teikeiCourseFilterConditions.teikeiCourseNo) !== -1) &&
      (!self.teikeiCourseFilterConditions.teikeiCourseNm || elem.teikeiCourseNm.indexOf(self.teikeiCourseFilterConditions.teikeiCourseNm) !== -1) &&
      (!self.teikeiCourseFilterConditions.tokuisakiCd || elem.tokuisakiCd === self.teikeiCourseFilterConditions.tokuisakiCd) &&
      (!self.teikeiCourseFilterConditions.chumonNo || elem.chumonNo === self.teikeiCourseFilterConditions.chumonNo) &&
      (!self.teikeiCourseFilterConditions.tantoEigyoshoCd || elem.tantoEigyoshoCd === self.teikeiCourseFilterConditions.tantoEigyoshoCd) &&
      (!self.teikeiCourseFilterConditions.hacchusakiCd || elem.hacchusakiCd === self.teikeiCourseFilterConditions.hacchusakiCd) &&
      (!self.teikeiCourseFilterConditions.hatsuchiNm || String(elem.hatsuchiNm).indexOf(self.teikeiCourseFilterConditions.hatsuchiNm) !== -1 || String(elem.hatsuchiBiko).indexOf(self.teikeiCourseFilterConditions.hatsuchiNm) !== -1) &&
      (!self.teikeiCourseFilterConditions.chakuchiNm || String(elem.chakuchiNm).indexOf(self.teikeiCourseFilterConditions.chakuchiNm) !== -1 || String(elem.chakuchiBiko).indexOf(self.teikeiCourseFilterConditions.chakuchiNm) !== -1)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      console.log('NewButton pushed')
      const p = modals.showConfirm
      p('COMQ0006').then((ok) => {
        console.log('clearInputs')
        if (ok === false || ok === undefined) { return }
        this.initBindVariables()
        this.searchText = ''
        this.rows = this.itemList
        this.selected = []
      })
      this.Effects.loadComplete()
    },
    onCloseClick: function (e) {
      /**
       * 無選択クローズ処理
       * @event click
       * @type {Event}
       */
      console.log('close clicked', this.showDialog)
      this.dialog = false
      this.$emit('close', false)
      console.log('emited', this.showDialog)
      // this.clear(false)
      this.initBindVariables()
      this.searchText = ''
      this.selected = []
    },
    searchValidate: function () {
      return true
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      this.rows = this.itemList
      this.conditions = {
        teikeiCourseNo: '',
        teikeiCourseNm: '',
        tokuisakiCd: '',
        chumonNo: '',
        tantoEigyoshoCd: '',
        hacchusakiCd: '',
        hatsuchiNm: '',
        chakuchiNm: ''
      }
      this.teikeiCourseFilterConditions = Object.assign({}, this.conditions)
    },

    // ----------------------------------------------------------------------------------------------------
    // ページ遷移
    // ----------------------------------------------------------------------------------------------------
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },

    // ダイアログメッセージ
    showError: function (msg) {
      Swal.fire({
        icon: 'error',
        html: msg
      })
    },
    showSuccess: function (msg) {
      Swal.fire({
        icon: 'success',
        html: msg
      })
    },
    getRowKey (row, rowIndex) {
      // itemKey が指定されていて、row にそのプロパティがあればそれを使う
      if (this.itemKey && row && row[this.itemKey] !== undefined && row[this.itemKey] !== null) {
        return row[this.itemKey]
      }
      // 無ければ index
      return rowIndex
    }
  }
}
</script>
<style scoped>
div.v-dialog__content.v-dialog__content--active {
   z-index: 520 !important;
}
</style>
